import React from 'react';
import { useTranslation } from 'react-i18next';

export const TabButton = ({
  activeClassName = '',
  className = '',
  inactiveClassName = '',
  isActive,
  title,
  value,
  onClick,
}: {
  className?: string;
  activeClassName?: string;
  inactiveClassName?: string;
  title: string;
  value: string | number;
  isActive?: boolean;
  onClick: React.Dispatch<React.SetStateAction<string | number | undefined>>;
}) => {
  return (
    <div
      className={`
        ${className}
        flex
        justify-center
        items-center
        cursor-pointer
        ${
          isActive
            ? `${activeClassName} text-black font-bold dark:text-white`
            : `${inactiveClassName} text-grey-50`
        }
      `}
      onClick={() => onClick(value)}
    >
      {title}
    </div>
  );
};

export default TabButton;
